export const mapConfig = {
  center: {
    lat: 42.82683672791135, // centriranje na Crnu Goru, koordinate nisu geografski centar, pokupljeno je otprilike sa google mapa
    lng: 19.22930274310185
  },
  zoom: 7,
  disableDefaultUI: true
}

export const apiKey = '' // AIzaSyDGcaemLdzDQglgCXu9zKL8RlM9Jldbg5M
